var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-banner'),_c('introduce'),_c('home-api-list'),_c('customer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }